import {
  useSelector,
  useTooltipSnapshot,
} from '../../../../core/components/overlay-tooltip/selectors.js';
import { UndefinedContent, type TooltipContent } from '../../../types/state.js';

const VariantToGeometryMap = {
  linear: new Set(['dot', 'line', 'area']),
  rectangle: new Set(['rect', 'bar']),
} as const;

export const useTooltipMetadata = (
  variant: 'linear' | 'rectangle',
): TooltipContent | typeof UndefinedContent => {
  // trigger a re-render when tooltip.content contains a datapoint matching VariantToGeometryMap[variant].
  // subscribers of the other variant will still re-render once on the transition away from their geometry type,
  // but will stabilize afterwards (selector returns undefined, which stays stable until the next matching type arrives).
  useSelector(({ data }) => {
    const metadata =
      (data?.metadata as TooltipContent | typeof UndefinedContent) ||
      UndefinedContent;
    if (VariantToGeometryMap[variant].has(metadata.type)) {
      return ((metadata as TooltipContent) || UndefinedContent || undefined)
        ?.datapoint;
    }
  });

  // since the selector is narrowed down to the datapoint,
  // read the full metadata here without subscribing again to the store.
  const { data } = useTooltipSnapshot();
  return (data.metadata as TooltipContent) || UndefinedContent;
};
